import React, { useCallback, useState } from "react";
import Hero from "../../components/pages/News/Hero/Hero";
import Posts from "../../components/pages/News/Posts/Posts";
import "./News.css";

const News = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [filters, setFilters] = useState(["All"]);

  const handleFiltersReady = useCallback((categories) => {
    setFilters(["All", ...categories]);
    setActiveFilter((current) =>
      current === "All" || categories.includes(current) ? current : "All"
    );
  }, []);

  return (
    <div className="news-page">
      <div className="news-page__grid-section">
        <Hero
          activeFilter={activeFilter}
          onFilterChange={setActiveFilter}
          filters={filters}
        />
      </div>
      <Posts activeFilter={activeFilter} onFiltersReady={handleFiltersReady} />
    </div>
  );
};

export default News;
